module.exports = __webpack_public_path__ + "img/portugal.a36b3d87.svg";